"use client";

import Image from "next/image";
import { cn } from "@/lib/utils";

type RadiumLogoVariant = "wordmark" | "icon";
type RadiumLogoTheme = "dark" | "light";

type RadiumLogoProps = {
  variant?: RadiumLogoVariant;
  theme?: RadiumLogoTheme;
  alt?: string;
  className?: string;
};

const logoPath = (variant: RadiumLogoVariant, theme: RadiumLogoTheme): string => {
  const prefix = variant === "icon" ? "radium-icon" : "radium-logo";
  return `/brand/${prefix}-${theme}.svg`;
};

export const RadiumLogo = ({ variant = "wordmark", theme, alt = "Radium logo", className }: RadiumLogoProps) => {
  if (theme) {
    return (
      <Image
        src={logoPath(variant, theme)}
        alt={alt}
        width={0}
        height={0}
        sizes="100vw"
        className={cn("h-auto w-auto max-w-none", className)}
      />
    );
  }

  return (
    <>
      <Image
        src={logoPath(variant, "dark")}
        alt={alt}
        width={0}
        height={0}
        sizes="100vw"
        className={cn("block dark:hidden h-auto w-auto max-w-none", className)}
      />
      <Image
        src={logoPath(variant, "light")}
        alt={alt}
        width={0}
        height={0}
        sizes="100vw"
        className={cn("hidden dark:block h-auto w-auto max-w-none", className)}
      />
    </>
  );
};
